import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HeaderNavigation as CheHeaderNavigation } from '@che-ins-ui/header';
import { useNavigateToMainPage } from '@/components/insurance/components/hooks';
import { currentStepSelector, insuranceStepsSelector, previousStepSelector, } from '@/models/steps/selectors';
import { setStep } from '@/models/steps/setStep';
import { isIframe } from '@/libs/helpers';
import { useStyles } from '../Header/styles';
const NON_INSURANCE_STEPS_COUNT = 1;
export const HeaderNavigation = memo(() => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const currentStep = useSelector(currentStepSelector);
    const previousStep = useSelector(previousStepSelector);
    const insuranceSteps = useSelector(insuranceStepsSelector);
    const navigateToShowcase = useNavigateToMainPage();
    const currentStepIndex = insuranceSteps.findIndex(({ formStepKey }) => formStepKey === currentStep);
    const onClick = () => {
        if (currentStepIndex === 0) {
            navigateToShowcase();
            return;
        }
        dispatch(setStep(previousStep));
    };
    if (isIframe()) {
        return null;
    }
    const { title } = insuranceSteps[currentStepIndex];
    const stepNumber = currentStepIndex + NON_INSURANCE_STEPS_COUNT + 1;
    const totalStepsCount = insuranceSteps.length + NON_INSURANCE_STEPS_COUNT;
    return (_jsx("div", { className: classes.root, "data-not-centered": true, children: _jsx(CheHeaderNavigation, { homepageUrl: __HOMEPAGE__, withBackButton: true, onBackButtonClick: onClick, title: title, description: `Шаг ${stepNumber}/${totalStepsCount}` }) }));
});
